import { IonRouterOutlet } from '@ionic/react';

import { Maintenance, NoAccess, NoInternet, Update } from '@/pages/overlays';
import { ROUTES } from '@/utils/routes';
import { Redirect, Route } from 'react-router-dom';

interface OverlaysProps {
  connected?: boolean | null | undefined;
  forceUpdate?: boolean | null | undefined;
  noAccess?: boolean | null | undefined;
}

const Overlays: React.FC<OverlaysProps> = ({
  connected,
  forceUpdate,
  noAccess
}) => {
  const renderRootContent = () => {
    if (noAccess) {
      return <NoAccess />;
    }

    if (!connected) {
      return <Redirect to={ROUTES.NO_INTERNET} />;
    }

    if (forceUpdate) {
      return <Redirect to={ROUTES.UPDATE} />;
    }

    return <Redirect to={ROUTES.MAINTENANCE} />;
  };

  return (
    <IonRouterOutlet animated={false}>
      {/* Overlays Routes */}
      <Route exact path={ROUTES.ROOT}>
        {renderRootContent()}
      </Route>
      <Route exact path={ROUTES.NO_INTERNET}>
        <NoInternet />
      </Route>
      <Route exact path={ROUTES.UPDATE}>
        <Update />
      </Route>
      <Route exact path={ROUTES.MAINTENANCE}>
        <Maintenance />
      </Route>

      {/* Redirect non-overlays routes to root */}
      <Route>
        <Redirect to={ROUTES.ROOT} />
      </Route>
    </IonRouterOutlet>
  );
};

export default Overlays;
